import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var HomeIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M11.4 1.4c.3-.3.8-.3 1.2 0l10 8c.4.4.5 1 .2 1.4-.2.3-.5.4-.8.4-.2 0-.4-.1-.6-.2l-.4-.319V20c0 1.64-1.209 2.907-2.82 2.995L18 23H6c-1.7 0-3-1.3-3-3v-9.319L2.6 11c-.37.277-.994.213-1.324-.113L1.2 10.8c-.3-.4-.2-1 .2-1.4zm.6 2.1L5 9.085V20c0 .557.345.942.875.994L6 21h2v-7a2 2 0 011.85-1.995L10 12h4a2 2 0 011.995 1.85L16 14v7h2c.6 0 1-.4 1-1V9.085L12 3.5zM14 14h-4v7h4v-7z",
                        fillRule: "evenodd"
                    })
                })
            })
        ]
    });
};
HomeIcon.isCarinaIcon = true;
export default HomeIcon;
